import Spotify4 from './Spotify4'
export default Spotify4
